var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#141414",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.16
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7257 10H20.1646C20.1736 10.0958 20.1724 10.192 20.1712 10.2882C20.1715 12.4118 20.171 14.5355 20.1715 16.6594C20.6358 16.6523 21.1003 16.6578 21.5646 16.6562C21.8628 16.6597 22.1617 16.6466 22.4595 16.6666C22.5561 16.6704 22.6523 16.6594 22.7486 16.6562C22.9347 16.656 23.1209 16.6557 23.307 16.6578C23.4112 16.6547 23.5155 16.6542 23.6193 16.6642L23.5966 16.6653C23.5003 16.6646 23.404 16.6646 23.3076 16.6688C22.6417 16.6699 21.9756 16.6715 21.3096 16.6672C20.9292 16.672 20.5488 16.6702 20.1683 16.668C19.0366 16.668 17.9049 16.6688 16.7732 16.6675C16.3793 16.6568 15.9862 16.5824 15.6193 16.4373C15.0529 16.2158 14.5505 15.835 14.1825 15.351C13.8369 14.8987 13.6102 14.3563 13.5334 13.7922C13.4504 13.1923 13.5323 12.5698 13.7737 12.0139C14.048 11.3754 14.5288 10.8283 15.1252 10.472C15.6073 10.1814 16.164 10.0213 16.7257 10Z",
    fill: "#F24E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1641 10H23.5882C24.1484 10.016 24.7044 10.172 25.187 10.4574C25.6798 10.7464 26.0959 11.1643 26.3831 11.6581C26.6103 12.047 26.7567 12.4829 26.8103 12.9302C26.8321 13.1366 26.8555 13.345 26.8279 13.552C26.7945 14.0595 26.6443 14.559 26.3887 14.9989C26.0948 15.5082 25.6638 15.9373 25.153 16.2288C24.6873 16.496 24.1556 16.6472 23.6188 16.6642C23.515 16.6542 23.4106 16.6547 23.3065 16.6578C23.1204 16.6557 22.9342 16.656 22.7481 16.6562C22.6518 16.6594 22.5556 16.6704 22.459 16.6666C22.1612 16.6466 21.8623 16.6597 21.5641 16.6562C21.0997 16.6578 20.6353 16.6523 20.1709 16.6594C20.1705 14.5355 20.1709 12.4118 20.1706 10.2882C20.1719 10.192 20.173 10.0958 20.1641 10Z",
    fill: "#FF7262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1917 17.0995C15.6714 16.8264 16.2203 16.6763 16.7723 16.6675C17.904 16.6688 19.0357 16.668 20.1674 16.668C20.1691 17.7249 20.1656 18.7819 20.1693 19.8389C20.1691 19.8441 20.1688 19.8547 20.1687 19.86C20.1659 21.0176 20.1688 22.1755 20.1675 23.3333C19.0312 23.3338 17.8949 23.3338 16.7586 23.3331C16.3064 23.3214 15.8562 23.22 15.4451 23.0302C14.9221 22.7905 14.4639 22.4123 14.128 21.9453C13.7947 21.4838 13.5829 20.9355 13.5215 20.3696C13.4538 19.764 13.5544 19.1401 13.8141 18.5886C14.1047 17.9656 14.5935 17.4379 15.1917 17.0995Z",
    fill: "#A259FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3072 16.6689C23.4036 16.6647 23.4999 16.6647 23.5962 16.6653C24.1668 16.6863 24.7332 16.8469 25.2216 17.1447C25.762 17.4703 26.2068 17.9522 26.4872 18.5173C26.7212 18.9805 26.8317 19.4991 26.841 20.0161C26.8269 20.4373 26.7532 20.8594 26.5919 21.2505C26.2831 22.0181 25.6768 22.6601 24.9285 23.0129C24.4215 23.2548 23.8522 23.3623 23.2919 23.3266C22.7443 23.2933 22.2059 23.1212 21.741 22.8301C21.2386 22.5177 20.8221 22.0692 20.5477 21.545C20.2749 21.0297 20.1487 20.442 20.1691 19.8601C20.1693 19.8548 20.1696 19.8442 20.1698 19.8389C20.1808 19.7113 20.1906 19.5833 20.2123 19.457C20.3072 18.8724 20.564 18.3156 20.9448 17.8621C21.3384 17.3909 21.864 17.0309 22.4469 16.8373C22.7247 16.7426 23.0155 16.6935 23.3072 16.6689Z",
    fill: "#1ABCFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7585 23.333C17.8948 23.3336 19.0312 23.3336 20.1675 23.3332C20.1678 24.4463 20.1678 25.5594 20.1675 26.6725C20.1672 27.1932 20.043 27.7135 19.8057 28.1772C19.5267 28.7263 19.0921 29.1948 18.5659 29.5148C18.0758 29.8157 17.5065 29.9808 16.9324 29.9999H16.7396C16.4835 29.9895 16.228 29.9554 15.9801 29.8888C15.3848 29.7324 14.8363 29.4047 14.4139 28.9573C13.8664 28.3831 13.5356 27.6079 13.5044 26.8149C13.4777 26.2333 13.6062 25.6452 13.8764 25.1292C14.171 24.5618 14.6329 24.0831 15.1891 23.7676C15.6654 23.4949 16.2102 23.3471 16.7585 23.333Z",
    fill: "#0ACF83"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -9.5,
    y: -10,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFigma);
export default __webpack_public_path__ + "static/media/ic_figma.7aeec3d0ca5baf762a9ecb559c795d86.svg";
export { ForwardRef as ReactComponent };